
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/liftoff",
      function () {
        return require("private-next-pages/destinations/liftoff.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/liftoff"])
      });
    }
  